// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7c07a140","977":"c498bb0d"}[chunkId] + ".chunk.js";
};